import { Message } from "element-ui";
import { Toast } from "vant";
import { isMobile } from "@/utils/device";

/**
 * 通用消息提示函数
 * @param {Object|String} options 配置项或消息文本
 */
const showMessage = (options) => {
  let msg = "";
  let type = "info";
  let duration = 2000;
  let silentOn = null; // 限制哪个端不显示: 'mobile' | 'pc'

  if (typeof options === "string") {
    msg = options;
  } else {
    msg = options.message;
    type = options.type || "info";
    duration = options.duration || 2000;
    silentOn = options.silentOn;
  }

  // 如果当前设备匹配 silentOn，则不显示消息
  if (
    (isMobile() && silentOn === "mobile") ||
    (!isMobile() && silentOn === "pc")
  ) {
    return;
  }

  if (isMobile()) {
    // 移动端使用 Vant Toast
    let vantType = "text"; // 默认文本

    // 映射 Element UI 类型到 Vant 类型
    switch (type) {
      case "success":
        vantType = "success";
        break;
      case "error":
        vantType = "fail";
        break;
      case "warning":
        // Vant 没有 warning 类型，使用 fail 类型但图标可能不同，或者直接用 text
        // 这里为了区分，可以使用 text 模式，或者根据需求定制
        // 简单起见，warning 也用 text，或者使用 fail
        vantType = "fail";
        break;
      case "info":
      default:
        vantType = "text";
        break;
    }

    // 特殊处理 warning，如果需要自定义图标可以在这里扩展
    // 目前保持简单映射
    if (type === "warning") {
      // Vant Toast 支持 icon 选项
      Toast({
        message: msg,
        icon: "warning-o", // 使用 Vant 内置的警告图标
        duration,
      });
    } else {
      Toast({
        message: msg,
        type: vantType,
        duration,
      });
    }
  } else {
    // PC 端使用 Element UI Message
    Message({
      message: msg,
      type: type,
      duration: duration,
    });
  }
};

// 构造最终导出的对象，使其可以直接调用，也可以调用子方法
const $myMessage = (options) => {
  showMessage(options);
};

// 挂载快捷方法: $message.success('ok')
["success", "warning", "info", "error"].forEach((type) => {
  $myMessage[type] = (message, options = {}) => {
    // 允许传入对象覆盖默认配置
    if (typeof message === "object" && message !== null) {
      showMessage({ ...message, type, ...options });
    } else {
      showMessage({ message, type, ...options });
    }
  };
});

export default $myMessage;
